import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { Client } from "../../../core/api-client/api-client";
import { API_UPLOAD_ADMIN_DOCUMENT_PATH, API_UPLOAD_DOCUMENT_PATH } from "../../../core/route/api.routes";
const config = {
  name: "upload",
};
export const uploadFilePath: any = createAsyncThunk(
  `${config.name}/uploadFilePath`,
  async (data: any) => {
    return await Client.post(API_UPLOAD_DOCUMENT_PATH, data);
  }
);
export const uploadFilePathAdmin: any = createAsyncThunk(
  `${config.name}/uploadFilePathAdmin`,
  async (data: any) => {
    return await Client.get(API_UPLOAD_ADMIN_DOCUMENT_PATH, {params: data});
  }
);

export const uploadSlice = createSlice({
  name: config.name,
  initialState: {},
  reducers: {
    reset: (state) => {},
  },
  extraReducers(builder) {},
});

export const { reset } = uploadSlice.actions;

export default uploadSlice.reducer;
